module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.stockFilters,
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "仓库属性 :"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "仓库列表",
      "size": "small",
      "disabled": !_vm.stockFilters.IsAdmin
    },
    on: {
      "change": _vm.getWA
    },
    model: {
      value: (_vm.stockFilters.WID),
      callback: function($$v) {
        _vm.$set(_vm.stockFilters, "WID", $$v)
      },
      expression: "stockFilters.WID"
    }
  }, _vm._l((_vm.warehouses), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": item.Code + item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "库区",
      "size": "small"
    },
    on: {
      "change": _vm.getWAR
    },
    model: {
      value: (_vm.stockFilters.WAID),
      callback: function($$v) {
        _vm.$set(_vm.stockFilters, "WAID", $$v)
      },
      expression: "stockFilters.WAID"
    }
  }, _vm._l((_vm.WAList), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": item.ACode + ' - ' + item.Types
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "所有库位",
      "size": "small"
    },
    on: {
      "change": _vm.getWS
    },
    model: {
      value: (_vm.stockFilters.WARID),
      callback: function($$v) {
        _vm.$set(_vm.stockFilters, "WARID", $$v)
      },
      expression: "stockFilters.WARID"
    }
  }, _vm._l((_vm.WARList), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": item.RName
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "货主",
      "size": "small"
    },
    on: {
      "change": _vm.getWS
    },
    model: {
      value: (_vm.stockFilters.OwnerID),
      callback: function($$v) {
        _vm.$set(_vm.stockFilters, "OwnerID", $$v)
      },
      expression: "stockFilters.OwnerID"
    }
  }, _vm._l((_vm.ownerList), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": item.Code
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.stockSend
    }
  }, [_vm._v("库存推送")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "库存属性 :"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "库存编码/包裹编码",
      "size": "small"
    },
    model: {
      value: (_vm.stockFilters.KeyWord),
      callback: function($$v) {
        _vm.$set(_vm.stockFilters, "KeyWord", $$v)
      },
      expression: "stockFilters.KeyWord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "流水时间 :"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "开始日期",
      "size": "small"
    },
    model: {
      value: (_vm.stockFilters.StartTime),
      callback: function($$v) {
        _vm.$set(_vm.stockFilters, "StartTime", $$v)
      },
      expression: "stockFilters.StartTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "结束日期",
      "size": "small"
    },
    model: {
      value: (_vm.stockFilters.EndTime),
      callback: function($$v) {
        _vm.$set(_vm.stockFilters, "EndTime", $$v)
      },
      expression: "stockFilters.EndTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有库存"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "name": "type"
    },
    model: {
      value: (_vm.stockFilters.IsStock),
      callback: function($$v) {
        _vm.$set(_vm.stockFilters, "IsStock", $$v)
      },
      expression: "stockFilters.IsStock"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品属性 :"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "产品类型",
      "size": "small"
    },
    on: {
      "change": _vm.getWS
    },
    model: {
      value: (_vm.stockFilters.ProductTypes),
      callback: function($$v) {
        _vm.$set(_vm.stockFilters, "ProductTypes", $$v)
      },
      expression: "stockFilters.ProductTypes"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "True",
      "label": "显示包裹内产品"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "False",
      "label": "不显示包裹内产品"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearchSpu,
      "placeholder": "SPU / Name / SkuID",
      "size": "small"
    },
    on: {
      "select": _vm.handleSelectSpu
    },
    model: {
      value: (_vm.spuName),
      callback: function($$v) {
        _vm.spuName = $$v
      },
      expression: "spuName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-autocomplete', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "ID / SKU / Name",
      "size": "small"
    },
    on: {
      "select": _vm.handleSelectSearch
    },
    model: {
      value: (_vm.skuName),
      callback: function($$v) {
        _vm.skuName = $$v
      },
      expression: "skuName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.getWS
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.exportStockCode
    }
  }, [_vm._v("导出库存条码")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.stockList,
      "highlight-current-row": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "DataID",
      "label": "序号",
      "sortable": "",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "位置",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.Rack.Rcode) + " "), _c('br'), _vm._v(" " + _vm._s(scope.row.Rack.Types))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库存编码",
      "prop": "OrderID",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包裹编码",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.Package.FreightNo) + " "), _c('br'), _vm._v(" " + _vm._s(scope.row.Package.Name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "产品信息",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.Package.Product), function(pro) {
          return _c('p', [_vm._v("[" + _vm._s(pro.Product.FullName) + "]" + _vm._s(pro.Product.FullSKU) + " * " + _vm._s(pro.Product.Quantity))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包裹规格",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.Package.Weight) + "g "), _c('br'), _vm._v(_vm._s(scope.row.Package.Length) + " * " + _vm._s(scope.row.Package.Width) + " * " + _vm._s(scope.row.Package.Height) + "cm")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库存",
      "prop": "",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.Quantity))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm._f("cutDate")(scope.row.Date)) + " "), _c('br'), _vm._v(" " + _vm._s(_vm._f("cutDate")(scope.row.UpdateDate)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("流水")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "page-sizes": [20, 30, 50, 100],
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '指定包裹的库存流水: ' + _vm.activeStock,
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false,
      "custom-class": "el-dialog--large"
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "流水时间 :"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "开始日期"
    },
    model: {
      value: (_vm.stockFilters.StartTime),
      callback: function($$v) {
        _vm.$set(_vm.stockFilters, "StartTime", $$v)
      },
      expression: "stockFilters.StartTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "结束日期"
    },
    model: {
      value: (_vm.stockFilters.EndTime),
      callback: function($$v) {
        _vm.$set(_vm.stockFilters, "EndTime", $$v)
      },
      expression: "stockFilters.EndTime"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.downloadFlow
    }
  }, [_vm._v("导出流水")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.editForm.Flow,
      "highlight-current-row": "",
      "border": "",
      "max-height": "400"
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "库存编码",
      "prop": "FreightNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "原数量",
      "width": "",
      "prop": "OldQuantity"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "流水",
      "width": "",
      "prop": "Quantity"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "来源单号",
      "width": "",
      "prop": "ReferenceID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时间",
      "width": "",
      "prop": "Date"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8df04ef8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/stockManage/stockList.vue
// module id = 845
// module chunks = 1